import { Component, ViewChild, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { LicensesFacade } from 'mbs-ui-shared@facades/licenses.facade';

@Component({
  selector: 'msp-buy-license-modal',
  templateUrl: './buy-license-modal.component.html',
  standalone: true,
  imports: [ButtonComponent, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class BuyLicenseModalComponent {
  private licensesFacade = inject(LicensesFacade);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public get licenseType(): number {
    return this.baseModal.data?.licenseType;
  }

  public proceed(): void {
    this.licensesFacade.proceedWithAutoAssign(this.licenseType, this.baseModal.data?.hid);
  }
}
